import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PostRefundCreateProcedure,
	PostRefundCreateProcedureParams,
	PostRefundCreateProcedureResponse,
} from 'domain/usecases/private/refund/request/post-create-procedure';

export class RemoteRefundPostCreateProcedure implements PostRefundCreateProcedure {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostRefundCreateProcedureResponse>,
	) {}

	async post(
		params: PostRefundCreateProcedureParams,
	): Promise<PostRefundCreateProcedureResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
